<template>
  <v-dialog v-if="showMessage" v-model="computedShowMessage" max-width="700">
    <v-card outlined class="modal-card" rounded="lg">
      <v-card-title class="d-flex justify-space-between">
        <span>
          <span>Message</span>
          <v-btn icon :loading="msgLoading" @click="refresh"><v-icon>mdi-refresh</v-icon></v-btn>
        </span>
        <v-btn @click="close" icon><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider class="my-2" />
      <v-card-text>
        <section class="d-flex flex-column py-5">
          <data-table :headers="headers" :data="computedMsg">
            <template v-slot:from="{ row }">
              <div class="d-flex align-center">
                <v-avatar size="20"><v-img :src="row.pathway.srcNetwork?.logo" aspect-ratio="1" contain /></v-avatar>
                <span class="ml-1">{{ row.pathway.srcNetwork?.name }}</span>
              </div>
            </template>
            <template v-slot:to="{ row }">
              <div class="d-flex align-center">
                <v-avatar size="20"><v-img :src="row.pathway.dstNetwork?.logo" aspect-ratio="1" contain /></v-avatar>
                <span class="ml-1">{{ row.pathway.dstNetwork?.name }}</span>
              </div>
            </template>
            <template v-slot:status="{ row }">
              <div class="d-flex align-center">
                <v-chip small :color="statusColor(row.status.name)" outlined>
                  <div class="text-capitalize">{{ row.status.name }}</div>
                </v-chip>
              </div>
            </template>
            <template v-slot:action="{ row }">
              <div class="d-flex align-center">
                <v-btn text small rounded @click="view(row.source)">view</v-btn>
                <v-btn v-if="row.status.name === 'failed'" text small rounded @click="execute(row)" color="primary">execute</v-btn>
              </div>
            </template>
          </data-table>
        </section>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { LAYERZERO_SCAN, LAYERZERO_TESTNET_SCAN } from '../../../constants'

export default {
  name: 'MessageModal',
  data() {
    return {
      headers: [
        { text: 'From', value: 'from', width: '3' },
        { text: 'To', value: 'to', width: '3' },
        { text: 'Status', value: 'status', align: 'center', width: '3' },
        { text: '', value: 'action', align: 'center', width: '3' },
      ],
    }
  },
  computed: {
    ...mapState('wallet', ['currentNetwork']),
    ...mapState('modal', ['showMessage']),
    ...mapState('message', ['msg', 'msgLoading']),
    computedMsg() {
      return this.msg.map(m => {
        return m
      })
    },
    computedShowMessage: {
      get() {
        return this.showMessage
      },
      set() {
        this.close()
      },
    }
  },
  watch: {},
  mounted() { },
  methods: {
    ...mapActions({
      getLayerzeroMsg: 'message/getLayerzeroMessage',
      executeLzReceive: 'message/executeLzReceive'
    }),
    close() {
      this.$store.commit('modal/HIDE_MESSAGE')
    },
    refresh() {
      this.getLayerzeroMsg()
    },
    statusColor(name) {
      switch (name) {
        case 'inflight':
          return 'blue'
        case 'delivered':
          return 'green'
        case 'failed':
          return 'red'
        default:
          break;
      }
    },
    view({ txHash }) {
      console.log('txHash', txHash)
      const baseURL = this.currentNetwork.isTestnet ? LAYERZERO_TESTNET_SCAN : LAYERZERO_SCAN
      window.open(`${baseURL}/tx/${txHash}`)
    },
    execute(data) {
      this.executeLzReceive(data)
    }
  },
}
</script>
<style lang="scss" scoped>
@import '@/style/_variable.scss';
</style>
